import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-a2-list-vistplan',
  templateUrl: './a2-list-vistplan.component.html',
  styleUrls: ['./a2-list-vistplan.component.scss']
})
export class A2ListVistplanComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); 
     /**
     * 设置默认当前年月
     */
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
  }

  // ngOnInit() {
  // }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    let that = this;
    console.log("20190871");
    // if(localStorage.getItem("spdate")){
    //   that.month = localStorage.getItem("spdate")+"-" + "01 00:00:00";
    //   that.searchDate=that.month;
    // }else{
    //   localStorage.removeItem("spdate");
    // }
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // }
    body.ConfigName = "ApprovalVisitPlanUserList";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      let obj = {};
      let temp:any={};
       if (!that.searchDate) {
        let nowyear: any = that.com.getNow.split('-')[0];
        let nowmonth: any = that.com.getNow.split('-')[1];
        temp["date"]=nowyear + "-" + nowmonth + "-" + "01";
        temp['beginDate'] = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        temp['endDate'] = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
       
      }else{
        if(that.searchDate && that.searcholdDate){
          temp["date"]=that.searchDate;
          temp['beginDate'] = that.searchDate;
          temp['endDate'] = that.searcholdDate;
        }

      }

      // obj["startdate"]=temp['beginDate'];
      obj["date"]= temp['date'];
      obj["state"]=that.segmentVal;
      // obj["type"]=5;
      // obj["a_Date"]=that.com.BetweenDate(temp.beginDate,temp.endDate);
      // obj["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
      body.RequestBody = JSON.stringify(obj);
    }
    console.log(123456);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          // that.element.selectItemList.selectItem.forEach((element, index) => {
          //   if (element.bindingField) {
          //     if(element.bindingField == "date"){
          //       objfield[element.bindingField] = { "value": item[element.field].replace(/-/g,"/"), "text": element.text };
          //     }else{
          //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
          //     }
          //   }
          // });
          that.dataArrayList.push(item);
          // console.log(that.element.selectItemList.selectItem);
          console.log(item);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  changeMonth(type, $event:any = "") {
    const that=this;
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01"; 
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
      
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    this.searchDate =startmonthDay;
    this.searcholdDate = endmonthDay;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }
  EventClick(index) {
    const that = this;
    that.segmentVal = index;
    that.LoadData(1);
  }
  EventLink(ev: any, parms: any) {
    console.log(ev);
    let evs = ev.url || '';
    let d = new Date(this.month);
    let current = d.getFullYear() + "-" + (d.getMonth()+1);
    console.log(evs, parms);
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs, '详情');
      } else {
        // this.router.navigateByUrl(evs + "/GETEDITE/");
        //TODO:跳转方法
        this.segmentVal?this.segmentVal:0;
        // this.router.navigateByUrl(evs + "/1/" + parms.SystemUser_ID.value);
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" + parms.FK_SystemUser_ID.value + "&" +current+"&"+this.com.getNowDatetime);
        // this.router.navigateByUrl(evs + "/" + this.segmentVal + "/" + parms.ID + "&" +current+"&"+this.com.getNowDatetime);
        this.com.Go(evs + "/" + this.segmentVal + "/" + parms.ID + "&" +current+"&"+this.com.getNowDatetime);
      }
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }


  checkItem(item){
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
  }
    /**
   * 审批
   * @param event 通过:true,驳回:false
   */
  EventSubmit(event: Boolean) {
    // console.log(event);
    const that = this;
    that.msg.Show("暂未开通");
    return;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalSystemUser";//审批人审批
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        if (items.isCheck) {
          that.addobject.push(items.SystemUser_ID.value);//用户ID
        }
      });

      if(that.addobject.length<=0){
        that.msg.Alert("请选择需要审批的数据");
        return;
      }
      let _bodyparms={};
      let users="";
      that.addobject.forEach(user=>{
          if(!users){
            users=user;
          }else{
            users +=","+user;
          }
      });
      users+=","+"711BBD40-6A3C-41CA-B288-925A415EB7B7";
           _bodyparms["userId"]=users;
           _bodyparms["date"]= that.month;
           if(event){
            _bodyparms["state"]=1;//审批通过
           }else{
            _bodyparms["state"]=2;//审批驳回
           }
           
       console.log(JSON.stringify(_bodyparms));
      webcontext.RequestBody = JSON.stringify(_bodyparms);
      console.log(JSON.stringify(webcontext));
      that.http.post(app.DEFAULTURL, webcontext).then(data => {
        if (data.ResponseMessage.Success) {
          that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  ///撤销数据
  EventApproveSubmit(){
    const that = this;
    that.msg.Show("暂未开通");
    return;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalSystemUser";//审批人审批
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        if (items.isCheck) {
          that.addobject.push(items.SystemUser_ID.value);//用户ID
        }
      });

      if(that.addobject.length<=0){
        that.msg.Alert("请选择需要撤销的数据");
        return;
      }
      let _bodyparms={};
      let users="";
      that.addobject.forEach(user=>{
          if(!users){
            users=user;
          }else{
            users +=","+user;
          }
      });
      // users+=","+"711BBD40-6A3C-41CA-B288-925A415EB7B7";
           _bodyparms["userId"]=users;
           _bodyparms["date"]= that.month;
           _bodyparms["state"]=3;//批量撤销
           
      //  console.log(JSON.stringify(_bodyparms));
      webcontext.RequestBody = JSON.stringify(_bodyparms);
      that.http.post(app.DEFAULTURL, webcontext).then(data => {
        if (data.ResponseMessage.Success) {
          that.msg.Alert("数据撤销成功").then(msg=>{
           if(msg){
            that.LoadData(1);
           }
          });
         
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }

}
